module.exports = __webpack_public_path__ + "static/media/02.f78078a8.png";